import { addListener, createListenerMiddleware, removeListener } from '@reduxjs/toolkit'

import {
  TAddListenerAction,
  TListenerMiddleware,
  TRemoveListenerAction,
  TStartListening,
  TStopListening,
} from '../models/typedListenerMiddleware'

const appListenerMiddleware = createListenerMiddleware()

export const listenerMiddleware = {
  middleware: appListenerMiddleware.middleware as TListenerMiddleware,
  addListenerAction: addListener as TAddListenerAction,
  removeListenerAction: removeListener as TRemoveListenerAction,
  startListening: appListenerMiddleware.startListening as TStartListening,
  stopListening: appListenerMiddleware.stopListening as TStopListening,
}
